import { TableColumnsType } from "antd";

/**
 * Format text for table display with automatic line breaks
 * Can be used for both table headers and cell content
 * @param text - The text to format
 * @param breakChars - Characters to break at (default: [' ', '-'])
 * @param maxLength - Maximum length before forcing a break (default: 8)
 * @returns JSX element with proper line breaks
 */
export const formatTableText = (text: string, breakChars: string[] = [" ", "-"], maxLength: number = 8): JSX.Element => {
  if (!text) return <span>{text}</span>;

  let result = text;

  // Replace break characters with line breaks
  breakChars.forEach((char) => {
    result = result.replace(new RegExp(`\\${char}`, "g"), "<br>");
  });

  // Handle long continuous text by adding breaks at maxLength
  const parts = result.split("<br>");
  const processedParts = parts.map((part) => {
    if (part.length > maxLength) {
      return part.match(new RegExp(`.{1,${maxLength}}`, "g"))?.join("<br>") || part;
    }
    return part;
  });

  return (
    <span
      dangerouslySetInnerHTML={{
        __html: processedParts.join("<br>"),
      }}
    />
  );
};

// Alias สำหรับ backward compatibility และความชัดเจนในการใช้งาน
export const formatColumnTitle = formatTableText;
export const formatCellText = formatTableText;

export const addCenterAlign = <T,>(columns: TableColumnsType<T>): TableColumnsType<T> => {
  return columns.map((column) => ({
    ...column,
    align: "center",
  }));
};
